import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import {parseTime} from "../../Utils";
import ItemList from "flarum/common/utils/ItemList";

export default class PlayerStatData extends Component<{
  player: any
}> {
  statName(key: string) {
    return key;
  }

  filter(key: string, data: any) {
    return true;
  }

  levelItems(data: any): ItemList<any> {
    const items = new ItemList();

    items.add("level", <div className="lvl">{data.level}</div>);

    return items;
  }

  view() {
    const data = this.attrs.player;

    return <div className="player-info">
      <p className="player-time">TA于{parseTime(data.create_time).toLocaleString()}加入罗德岛，上次在线时间为{parseTime(data.last_seen_time).toLocaleString()}</p>
      <div className="player-level">
        {this.levelItems(data).toArray()}
      </div>
      <div className="stats">
        {
          Object.keys(data).map((key) => {
            if (this.filter(key, data[key])) {
              return "";
            } else {
              return <div className="stat">
                <span className="player-stat-name">{app.translator.trans(/*"*/this.statName(key))}</span>
                <div className="stat-num">{new Intl.NumberFormat("en-US").format(data[key])}</div>
              </div>
            }
          })
        }
      </div>
    </div>
  }
}
